export default {
	ATA_REGISTRO_PRECO: { text: 'Ata De Registro De Preço', value: 'ATA_REGISTRO_PRECO', idKey: 'idAta', path: 'atas' },
	PEDIDO_UTILIZACAO: { text: 'Pedido de Utilização', value: 'PEDIDO_UTILIZACAO', idKey: 'idPedido', path: 'pedido' },
}
